module.exports = __webpack_public_path__ + "static/media/msTeams.8ebc6e8d.png";